module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebar"
  }, [_c('div', {
    staticClass: "p-2 flex items-center h-14 text-blue-dark bg-blue-darkest font-semibold text-xl px-4"
  }, [_c('router-link', {
    staticClass: "no-underline text-blue-dark",
    attrs: {
      "to": "/"
    }
  }, [_c('h1', {
    staticClass: "text-2xl tracking-wide uppercase"
  }, [_vm._v("\n        Eros\n      ")])])], 1), _vm._v(" "), _c('LoggedUserSection'), _vm._v(" "), _c('menu-item', {
    attrs: {
      "title": "Artigos"
    }
  }, [_c('product-SVG', {
    attrs: {
      "slot": "image"
    },
    slot: "image"
  }), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/inventory-pages"
    }
  }, [_vm._v("Folhas Inventário")]), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/products/movement"
    }
  }, [_vm._v("Criar Movimento")])], 1), _vm._v(" "), _c('menu-item', {
    attrs: {
      "title": "Pedidos"
    }
  }, [_c('order-SVG', {
    attrs: {
      "slot": "image"
    },
    slot: "image"
  }), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/orders"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/orders?isongoing=1"
    }
  }, [_vm._v("Em Curso")]), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/orders?missing=1"
    }
  }, [_vm._v("Art. em Falta")])], 1), _vm._v(" "), _c('menu-item', {
    attrs: {
      "title": "Compras"
    }
  }, [_c('supply-order-SVG', {
    attrs: {
      "slot": "image"
    },
    slot: "image"
  }), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/supply-orders"
    }
  }, [_vm._v("Recebidas")]), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/supply-orders?ongoing=true"
    }
  }, [_vm._v("Em Curso")])], 1), _vm._v(" "), _c('menu-item', {
    attrs: {
      "title": "Fornecedores"
    }
  }, [_c('supplier-icon', {
    attrs: {
      "slot": "image"
    },
    slot: "image"
  }), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/suppliers"
    }
  }, [_vm._v("Todos")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "list-reset mb-2 text-xs"
  }, [_c('li', {
    staticClass: "text-xs text-blue-dark pl-4 pr-2 py-2 cursor-pointer hover:bg-blue-light"
  }, [_c('router-link', {
    staticClass: "flex items-center no-underline font-normal",
    attrs: {
      "to": "/stocks"
    }
  }, [_c('StocksSVG'), _vm._v(" "), _c('span', {
    staticClass: "text-sm mb-0 ml-2 uppercase text-blue-dark no-underline hover:text-grey hover:no-underline font-normal mr-auto"
  }, [_vm._v("\n          Stocks\n        ")])], 1)], 1)]), _vm._v(" "), _c('menu-item', {
    attrs: {
      "title": "Guias"
    }
  }, [_c('transport-label-SVG', {
    attrs: {
      "slot": "image"
    },
    slot: "image"
  }), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/transport-label-list"
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/transport-label/new"
    }
  }, [_vm._v("Nova Guia")])], 1), _vm._v(" "), _c('menu-item', {
    attrs: {
      "title": "Tarefas"
    }
  }, [_c('tasks-SVG', {
    attrs: {
      "slot": "image"
    },
    slot: "image"
  }), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/tasks"
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('menu-item-link', {
    attrs: {
      "to": "/tasks?open"
    }
  }, [_vm._v("Em Aberto")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdfb7f80","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/SideMenu.vue
// module id = 625
// module chunks = 66